// this sets up all the connections we might need during this session
let connections = null;

const pc = require(`../shared/private/connections`)

const init = ({log=false} = {}) => {
  connections = {
    ap: {
      ...getConnectionOptions({ connectionType: 'ap', log }),
      clientApikey: 'b1209e8561732224e00aa9cede420d09'
    },
    fb: getConnectionOptions({connectionType: 'fb', log})
  };
  return connections;
};

export const getConnections = () => {
  // initialize if not already donw
  if(!connections) init();
  return connections;
};

export const getConnection = (type) => {
  return getConnections()[type]
}

export const getConnectionOptions = ({connectionType, source, log , verbose = false}) => {
  // the specific connector for the service required
  const connector = require(`../shared/private/services/${connectionType}`);
  // get which modes are set in the environment
  const modes =  pc.getModes({
    target: connectionType,
    source
  });
  // get the connection options
  const connection = connector.getConnection ({
    modes,
    log
  })
  // should only use this for debugging - it shows connection options
  if(verbose) console.log(connection);
  return connection;
}